module.exports = __webpack_public_path__ + "static/media/mobito-icon-white.03fb676b.svg";